import cn from 'classnames';
import * as React from 'react';

import PlanCost, { PlanCostProps } from 'blocks/Pricing/components/PlanCost';
import GradientBadge from 'components/GradientBadge';
import { block } from './utils';

type PickedCostProps = Pick<
  PlanCostProps,
  | 'cost'
  | 'previousCost'
  | 'density'
  | 'description'
  | 'period'
  | 'title'
  | 'theme'
>;

export interface PlanHeaderProps extends PickedCostProps {
  className?: string;
  icon: React.ReactNode;
  isLimitedTime?: boolean;
}

const PlanHeader: React.SFC<PlanHeaderProps> = ({
  className,
  cost,
  previousCost,
  density,
  description,
  icon,
  period,
  theme,
  title,
  isLimitedTime,
}) => (
  <div className={cn(block('header'), className)}>
    <div className={block('header-icon-container')}>
      {React.isValidElement(icon) &&
        React.cloneElement(icon, {
          className: cn(icon.props.className, block('header-icon')),
        })}

      {isLimitedTime && <GradientBadge contents="Limited Time" />}
    </div>

    <PlanCost
      {...{ cost, previousCost, density, description, period, theme, title }}
    />
  </div>
);

export default PlanHeader;
